exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-box .el-row[data-v-6cff7fe8] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-6cff7fe8]:last-child {\n    margin-bottom: 0;\n}\n.my-box .el-col[data-v-6cff7fe8] {\n  border-radius: 4px;\n}\n", ""]);

// exports
